function miamihotels() {

    if ( !$('#hotels').length ) {
        return;
    }

    var navhtml  = '';
    var hotelshtml = '';
    var featureds = '';
    var featuredscount = 0;

    $.get( 'https://www.delmayandpartners.com/event/QuantumJSON/code/UMF20' , function() {})
    .done(function(data) {

        $.each( data.tab_details, function( key, val ) {

            if(val.hotels.length < 1 ) {
                return;
            }

            navhtml += `<li><a class="btn-main gray-btn" data-group="${convertToSlug(val.hotel_location)}" href="#${convertToSlug(val.hotel_location)}">${val.hotel_location} (${val.hotels.length})</a></li>`;
            hotelshtml += `<ul class="hotel-group" id="${convertToSlug(val.hotel_location)}">`;

            val.hotels = val.hotels.sort(sortByProperty('rate'));

            $.each( val.hotels, function( k, v ) {
                var rating = Number(v.rating);
                var rating = rating * 20;
                var booklink = '';
                var title = v.hotel_name;
                if(v.booklink) {
                    booklink = `<a target="_blank" href="${v.booklink}" class="main-btn btn-lg gray-btn">Book Now</a>`;
                    bookurl = v.booklink;
                }
                if(v.callus) {
                    booklink = `<span class="not-available call-us">Call Us</span><br><span class="phone">${v.callus}</span>`;
                }
                if(v.closed) {
                    booklink = '<span class="not-available closed">Closed</span>';
                }
                if(v.soldout) {
                    booklink = '<span class="not-available sold-out">Sold Out</span>';
                }
                if(v.distance) {
                    distance = `<span class="distance">(${v.distance})</span>`;
                } else {
                    distance = '';
                }
                var greenhotel = '';
                if (
                    v.hotel_name == 'Miami Airport Marriott' ||
                    v.hotel_name == 'Hampton Inn and Suites Miami Midtown' ||
                    v.hotel_name == 'JW Marriott Marquis Miami'
                    ) {
                    var greenhotel = '<p style="display:inline-block; padding: 10px 0 20px; color: #71b24e; text-transform: uppercase; font-size: 13px; font-family:"helvetica-bold"><span class="fas fa-earth-americas"></span> Certified environmentally friendly and Mission: Home approved!</p>';}
                var price = '';
                if ( v.rate ) {
                    price = v.currency+' '+v.rate;
                }
                var featured_class = '';
                var featured_note = '';
                if ( v.Featured == 1) {
                    featured_class = 'class="featured"';
                    featured_note = '<p style="display:inline-block; padding: 5px 0 5px; margin-bottom: 0px; color: #b3d4fd; text-transform: uppercase; font-size: 14px; font-weight: bold;">Featured</p>';
                    ++featuredscount;
                }
                hotelshtml += `
                <li ${featured_class}>
                <div class="clearfix hotel">
                <div class="img"><img src="${v.image}" alt="${v.hotel_name}"></div>
                <div class="info">
                <h2>${title}</h2>
                <img src="${v.image}" alt="${v.hotel_name}">
                <span class="rating"><span class="fill" style="width:${rating}%"></span></span>
                <span class="address">${v.address}</span>
                ${distance}
                ${featured_note}
                ${greenhotel}
                </div>
                <div class="action"><h3>${price}</h3>${booklink}</div>
                </div>
                <div class="clear op50 lbreak3"></div>
                </li>
                `;
            });
            hotelshtml += '</ul>'
        });

        setTimeout(function(){

            $('#hotelsnav').html('<ul>'+navhtml+'</ul>');
            $('#hotels').html(hotelshtml);
            featuredscount = featuredscount / 2;
            if ( $("#hotels li.featured").length ) {
                $('#hotelsnav ul').prepend(`<li><a class="btn-main gray-btn" data-group="featured" href="#featured">Featured <span class="fhcount">(${featuredscount})</span></a></li>`);
                //$('#hotelsnav ul').append('<li><a class="btn-main gray-btn sort-btn" data-group="sort" href="sort">Sort by Highest Price <span class="fhcount"></span></a></li>');
                $('#hotels').prepend('<div class="hotel-group" id="featured"></div>');
                $('#all-hotels li.featured').each(function(){
                    var el = $(this);
                    $('#featured').append(el.html());
                });
                $('a[data-group="all-hotels"]').parent().remove();
                $('#all-hotels').remove();
            }


            $('#hotelsnav li>a').on('click', function(e){
                var el = $(this);
                var group = el.data('group');
                e.preventDefault();
                if ( el.hasClass('active') ) {
                    $('#'+group).reverseChildren();
                    return;
                }
                $('#hotelsnav li>a.active').removeClass('active');
                $('.hotel-group').hide().removeClass('active');
                $(`#${group}`).fadeIn(300).addClass('active');
                el.addClass('active');
            });

            $('#hotelsnav li>a:first').trigger('click');

        }, 150);

    });


}

$.fn.reverseChildren = function() {
    return this.each(function(){
        var $this = $(this);
        $this.children().each(function(){ $this.prepend(this) });
    });
};
